import AddBeneficiaryError from './AddBeneficiaryError';
class InvalidCode extends AddBeneficiaryError {
    constructor(options) {
        super('The provided verification code is invalid', options);
    }
}
export default InvalidCode;
